export default __webpack_public_path__ + "static/media/Q1-2.ebbc4a1a.jpg";